import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

import LoadingSpinner from '../partials/LoadingSpinner';
import DeleteSupplierAssignmentModal from './DeleteSupplierAssignmentModal';

import { assignmentsIndex, getAssignmentThresholds } from '../../redux/actions/assignments';
import { purchaseOrderAddItem } from '../../redux/actions/purchaseOrders';
// import { inventoryDetails } from '../../redux/actions/products';

// import InventoryDetailsModal from './InventoryDetailsModal';

const AssignmentList = ({
  payload, 
  activeSupplier, 
  activeShippingAddress, 
  assignments, 
  thresholds,
  continuationToken, 
  getAssignmentsPage, 
  addItem, 
  purchaseOrderLines, 
  getInventoryDetails,
  getRelatedThresholds,
  settings,
  accountUnits,
  }) => {
  const [page, setPage] = useState(0);
  const [showInventoryDetailsModal, setShowInventoryDetailsModal] = useState(false);
  const [activeProductId, setActiveProductId] = useState(null);
  const [activeVariationId, setActiveVariationId] = useState(null);

  const [modalProductId, setModalProductId] = useState(null);
  const [modalVariationId, setModalVariationId] = useState(null);
  const [modalOptions, setModalOptions] = useState(null);
  const [modalProductName, setModalProductName] = useState(null);
  const [modalType, setModalType] = useState(null);
  const [modalAssignment, setModalAssignment] = useState(null);
  const [showDeleteSupplierAssignmentModal, setShowDeleteSupplierAssignmentModal] = useState(false);
  const [modalY, setModalY] = useState(0);

  const [assignmentQuantities, setAssignmentQuantities] = useState({});

  useEffect(() => {
    getNextAssignmentPage();
  }, []);

  useEffect(() => {
    if(activeShippingAddress?.address && assignments.assignments.length > 0) {
      // Search for thresholds for each assignment
      assignments.assignments.forEach((assignment) => {
        if(assignment.variation_data) {
          // Do not search if currently searching
          if(thresholds.searchingAssignmentLocationThresholds.findIndex((key) => key === `${activeShippingAddress.id}/${parseInt(assignment.product_id)}/${assignment.variation_data.id}`) >= 0) { return; }

          // Do not search if already found
          if(Object.keys(thresholds.assignmentLocationThresholds).findIndex((key) => key === `${activeShippingAddress.id}/${parseInt(assignment.product_id)}/${assignment.variation_data.id}`) >= 0) { return; }

          // Search if the key doesn't exist
          getRelatedThresholds(payload, activeShippingAddress.id, assignment.variation_data.product_id, assignment.variation_data.id)
        } else {
          // Do not search if currently searching
          if(thresholds.searchingAssignmentLocationThresholds.findIndex((key) => key === `${activeShippingAddress.id}/${parseInt(assignment.product_id)}/null`) >= 0) { return; }

          // Do not search if already found
          if(Object.keys(thresholds.assignmentLocationThresholds).findIndex((key) => key === `${activeShippingAddress.id}/${parseInt(assignment.product_id)}/null`) >= 0) { return; }

          // Search if the key doesn't exist
          getRelatedThresholds(payload, activeShippingAddress.id, parseInt(assignment.product_id), null)
        }
      })
    }
  }, [assignments, activeShippingAddress]);

  const format = (value) => {
    return (accountUnits.currencyPrefix + (parseFloat(value) || 0).toFixed(parseInt(accountUnits.currencyPrecision)) + accountUnits.currencySuffix).replace('.', accountUnits.currencyDecimalSeparator);
  }

  const handleAdd = (assignment) => {
    let itemData = {};

    if(assignment.variation_data) {
      let relatedProduct = assignments.relatedProducts?.find(prod => prod.id === parseInt(assignment.product_id));

      itemData.productId = parseInt(assignment.product_id);
      itemData.variationId = assignment.variation_data.id;
      itemData.productName = relatedProduct?.name;
      itemData.imageUrl = assignment?.variation_data?.smallThumbnailUrl || relatedProduct.smallThumbnailUrl;
      itemData.options = assignment.variation_data.options;
      itemData.sku = assignment.variation_data.sku;
      itemData.upc = assignment.variation_data.upc;
      itemData.supplier_sku = assignment.supplier_sku;
      itemData.supplier_price = assignment.supplier_price;
      itemData.minimumOrder = assignment.minimum_order;

      if(settings?.settings?.order_multiples) {
        itemData.orderMultiple = assignment.order_multiple;
      }

      if(settings?.settings?.pack_quantities) {
        itemData.packQuantity = assignment.pack_quantity;
      }

      itemData.setQuantity = parseInt(assignmentQuantities[`${parseInt(assignment.product_id)}/${assignment.variation_data.id}`] || assignment.minimum_order || 1);
    } else {
      itemData.productId = parseInt(assignment.product_id);
      itemData.variationId = null;
      itemData.productName = assignment.product_data.name;
      itemData.imageUrl = assignment.product_data?.smallThumbnailUrl;
      itemData.options = null;
      itemData.sku = assignment.product_data.sku;
      itemData.upc = assignment.product_data.upc;
      itemData.supplier_sku = assignment.supplier_sku;
      itemData.supplier_price = assignment.supplier_price;
      itemData.minimumOrder = assignment.minimum_order;

      if(settings?.settings?.order_multiples) {
        itemData.orderMultiple = assignment.order_multiple;
      }

      if(settings?.settings?.pack_quantities) {
        itemData.packQuantity = assignment.pack_quantity;
      }

      itemData.setQuantity = parseInt(assignmentQuantities[`${assignment.product_id}/null`] || assignment.minimum_order || 1);
    }

    addItem(payload, itemData);
  }

  const showInventoryModal = (assignment) => {
    let productId = null;
    let variationId = null;

    if(assignment.variation_data) {
      productId = assignment.variation_data.product_id;
      variationId = assignment.variation_data.id;
      setActiveProductId(assignment.variation_data.product_id);
      setActiveVariationId(assignment.variation_data.id);
    } else {
      productId = parseInt(assignment.product_id);
      setActiveProductId(parseInt(assignment.product_id));
      setActiveVariationId(null);
    }

   getInventoryDetails(payload, productId, variationId);
   setShowInventoryDetailsModal(true);
  }

  const getPreviousAssignmentsPage = () => {
    let previousContinuationToken = assignments.assignmentsSearchStack[page - 2];
    getAssignmentsPage(payload, activeSupplier.id, previousContinuationToken.id, (page - 1));
    setPage(page - 1);
  }

  const getNextAssignmentPage = () => {
    getAssignmentsPage(payload, activeSupplier.id, assignments.assignmentsSearchStack[page].id, (page + 1));
    setPage(page + 1);
  }

  const updateAssignmentQuantityField = (event, key) => {
    let value = event.target.value;
    let newQuantities = { ...assignmentQuantities };

    newQuantities[key] = parseInt(value);
    setAssignmentQuantities(newQuantities);
  }

  const itemName = (assignment) => {
    if(assignment?.product_data?.name) {
      return assignment?.product_data?.name;
    }

    if(assignment?.variation_data?.name) {
      return assignment?.variation_data?.name;
    }

    let relatedProduct = assignments.relatedProducts?.find(related => parseInt(assignment.product_id) === related.id);

    if(relatedProduct) {
      return relatedProduct.name;
    }
  }

  const itemImageUrl = (assignment) => {
    if(assignment?.product_data?.smallThumbnailUrl) {
      return assignment?.product_data?.smallThumbnailUrl;
    }

    if(assignment?.variation_data?.smallThumbnailUrl) {
      return assignment?.variation_data?.smallThumbnailUrl;
    }

    let relatedProduct = assignments.relatedProducts?.find(related => parseInt(assignment.product_id) === related.id);

    if(relatedProduct) {
      return relatedProduct?.smallThumbnailUrl;
    }
  }

  const handleDeleteAssignment = (event, assignment) => {
    console.log(assignment);

    setModalProductId(assignment.product_id);
    setModalVariationId(assignment.variation_id);
    setModalOptions(false);
    setModalProductName('Product not found');
    setModalType(assignment.variation_id ? 'variation' : 'product');
    setModalAssignment(assignment);
    setModalY(event.pageY);

    setShowDeleteSupplierAssignmentModal(true);
  }

  return(
    <>
      <h4>Supplier Assignments</h4>

      <div className="flex-container">
        <div className="flex-1">
          <button
            className="btn btn-default"
            onClick={() => getPreviousAssignmentsPage()}
            disabled={page === 1}
          >
            <span className="svg-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.284 9.9992H15c.5523 0 1-.4477 1-1 0-.5522-.4477-1-1-1H5.284l2.7725-3.0035c.3746-.4059.3493-1.0385-.0565-1.4131-.4058-.3746-1.0385-.3493-1.413.0565L2.2651 8.321a1 1 0 0 0 0 1.3565l4.3217 4.6819c.3746.4058 1.0073.4311 1.4131.0565.4058-.3746.4311-1.0072.0565-1.4131L5.284 9.9992z"/></svg>
            </span>
            <span className="gwt-InlineLabel">Previous Assignments</span>
          </button>

          <button
            className="btn btn-default"
            onClick={() => getNextAssignmentPage()}
            disabled={assignments.lastPage}
          >
            <span className="gwt-InlineLabel">Next Assignments</span>
            <span className="svg-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.716 9.9992H3c-.5523 0-1-.4477-1-1 0-.5522.4477-1 1-1h9.716L9.9435 4.9958c-.3746-.4059-.3493-1.0385.0565-1.4131.4058-.3746 1.0385-.3493 1.4131.0565l4.3217 4.6819a1 1 0 0 1 0 1.3565l-4.3217 4.6819c-.3746.4058-1.0073.4311-1.4131.0565-.4058-.3746-.4311-1.0072-.0565-1.4131l2.7725-3.0036z"/></svg>
            </span>
          </button>
        </div>
      </div>

      <br/>

      <div className="full-width">
        <div>
          { assignments.isFetching &&
            <LoadingSpinner statusText="Loading Assignments" />
          }

          { assignments.assignments.length === 0 && !assignments.isFetching &&
            <div>
              <div className="text-center">
                <p>No assignments created for this supplier. Add supplier assignments to see them listed here.</p>
                <Link to="/assignments">
                  <button
                    className="btn btn-default"
                  >
                    <span className="svg-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M17.0001 2c0-.5523-.4477-1-1-1h-5c-.5523 0-1 .4477-1 1s.4477 1 1 1h2.5858L7.0002 9.5857c-.3906.3906-.3906 1.0237 0 1.4143.3905.3905 1.0237.3905 1.4142 0L15 4.4142V7c0 .5523.4477 1 1 1s1-.4477 1-1V2z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1 3c0-1.1046.8954-2 2-2h3c.5523 0 1 .4477 1 1s-.4477 1-1 1H3v12h12v-3c0-.5523.4477-1 1-1s1 .4477 1 1v3c0 1.1046-.8954 2-2 2H3c-1.1046 0-2-.8954-2-2V3z"/></svg>
                    </span>
                    <span className="gwt-InlineLabel">Manage supplier assignments</span>
                  </button>
                </Link>
              </div>
            </div>
          }

          { assignments.assignments.length > 0 &&
              <div className="zebra-stripe-children">
                { assignments.assignments.map(assignment =>
                  <lineitem>
                    <div className="has-hover sku-line">
                      <h4>{ assignment.variation_id ? 'Variation' : 'Product'} - { itemName(assignment) }</h4>
                      <div className="flex-container">
                        <div className="left-15">
                          { itemImageUrl(assignment) &&
                            <img src={itemImageUrl(assignment)} />
                          }                        </div>
                        <div className="flex-2">
                          <div className="left-15">
                            <h4>Assignment Details</h4>
                            <ul>
                              <li><strong>Supplier SKU</strong>: <span className="inline-text-tag">{ assignment.supplier_sku }</span></li>
                              <li><strong>Supplier Price</strong>: <span className="inline-text-tag">{ assignment.supplier_price ? format(assignment.supplier_price) : null }</span></li>
                              <li><strong>Minimum Order Quantity</strong>: <span className="inline-text-tag">{ assignment.minimum_order }</span></li>
                              { settings?.settings?.order_multiples && 
                                <li><strong>Order Multiple</strong>: <span className="inline-text-tag">{ assignment.order_multiple }</span></li>
                              }
                              { settings?.settings?.pack_quantities && 
                                <li><strong>Pack Quantity</strong>: <span className="inline-text-tag">{ assignment.pack_quantity }</span></li>
                              }
                            </ul>
                          </div>
                        </div>

                        <div className="flex-2">
                          <h4>Item Details</h4>
                          { !(assignment?.variation_data || assignment?.product_data) &&
                            <>
                              <div>No matching catalog data found for this assignment.</div>
                              <div>If this item still exists in your store, this may be a temporary error. If this item has been removed from your store, you may wish to delete this assignment.</div>
                            </>
                          }
                          { (assignment?.variation_data || assignment?.product_data) &&
                            <ul>
                              { assignment?.variation_data?.options && assignment?.variation_data?.options.map(option =>
                                  <li>
                                    <strong>{ option.name }</strong>: <span className="inline-text-tag inline-text-tag--light-half">{ option.value }</span>
                                  </li>
                                )
                              }
                              <li>
                                Current Stock: <span className="inline-text-tag inline-text-tag--light-half">{ assignment?.product_data?.quantity || assignment?.variation_data?.quantity }</span>
                              </li>
                            </ul>
                          }
                        </div>
                        <div className="flex-1">
                          { !(assignment?.variation_data || assignment?.product_data) &&
                            <button
                              className={`btn btn-default btn--destructive ${assignments.updatingAssignments.find(assignmentId => assignmentId === `${assignment.product_id}/${assignment.variation_id}`) ? 'btn-loading' : ''}`}
                              disabled={assignments.updatingAssignments.find(assignmentId => assignmentId === `${assignment.product_id}/${assignment.variation_id}`)}
                              onClick={(event) => handleDeleteAssignment(event, assignment)}
                            >
                              Delete Assignment
                            </button>
                          }

                          { (assignment?.variation_data || assignment?.product_data) &&
                            <div>
                                { !(Object.keys(purchaseOrderLines.lineDetails).find( (key) => (key === `${parseInt(assignment.product_id)}/${assignment?.variation_data?.id}` || (!assignment?.variation_data && key === `${parseInt(assignment.product_id)}/null`)) ) ) &&
                                  <>
                                    <div className="flex-container flex-end">
                                      <span>QTY: &nbsp;&nbsp;</span>
                                      <div className="width-50">
                                        <div className="fieldset">
                                          <div className="field field--medium field--filled">
                                            <span className="fieldset__svg-icon"></span>
                                            <label className="field__label">QTY</label>
                                            <input
                                              className="field__input"
                                              label=""
                                              onChange={(e) => updateAssignmentQuantityField(e, `${parseInt(assignment.product_id)}/${assignment?.variation_data?.id || 'null'}`)}
                                              type="number"
                                              value={assignmentQuantities[`${parseInt(assignment.product_id)}/${assignment?.variation_data?.id || 'null'}`] || parseInt(assignment.minimum_order) || 1}
                                            />
                                            <div className="field__placeholder">QTY</div>
                                            <span className="field-state--success"><svg xmlns="http://www.w3.org/2000/svg" width="26px" height="26px" viewBox="0 0 26 26" focusable="false"><path d="M5 12l5.02 4.9L21.15 4c.65-.66 1.71-.66 2.36 0 .65.67.65 1.74 0 2.4l-12.3 14.1c-.33.33-.76.5-1.18.5-.43 0-.86-.17-1.18-.5l-6.21-6.1c-.65-.66-.65-1.74 0-2.41.65-.65 1.71-.65 2.36.01z"></path></svg></span>
                                            <span className="field-state--close"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve" focusable="false"><path d="M15.6,15.5c-0.53,0.53-1.38,0.53-1.91,0L8.05,9.87L2.31,15.6c-0.53,0.53-1.38,0.53-1.91,0c-0.53-0.53-0.53-1.38,0-1.9l5.65-5.64L0.4,2.4c-0.53-0.53-0.53-1.38,0-1.91c0.53-0.53,1.38-0.53,1.91,0l5.64,5.63l5.74-5.73c0.53-0.53,1.38-0.53,1.91,0c0.53,0.53,0.53,1.38,0,1.91L9.94,7.94l5.66,5.65C16.12,14.12,16.12,14.97,15.6,15.5z"></path></svg></span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <button
                                      className="btn btn-default"
                                      onClick={() => handleAdd(assignment)}
                                    >
                                      <span className="svg-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M9.9968 8.0396h6.0302c.5374 0 .973.4356.973.973s-.4356.973-.973.973H9.9968V16c0 .5523-.4477 1-1 1h-.023c-.5523 0-1-.4477-1-1V9.9884H1.9744C1.4363 9.9884 1 9.5521 1 9.014s.4363-.9744.9744-.9744h5.9994V2c0-.5523.4477-1 1-1h.0244c.5523 0 1 .4477 1 1v6.0396h-.0014z"/></svg>
                                      </span>
                                      <span className="gwt-InlineLabel">Add to Purchase Order</span>
                                    </button>
                                  </>
                                }

                                { Object.keys(purchaseOrderLines.lineDetails).find( (key) => (key === `${parseInt(assignment.product_id)}/${assignment?.variation_data?.id}` || (!assignment.variation_data &&  key === `${parseInt(assignment.product_id)}/null`)) ) &&
                                  <button
                                    className="btn btn-default"
                                    disabled
                                  >
                                    <span className="svg-icon">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.1585.2474c.4156.3637.4578.9955.0941 1.4111l-7 8a1 1 0 0 1-1.4597.0486l-4-4c-.3905-.3905-.3905-1.0237 0-1.4142.3905-.3905 1.0237-.3905 1.4142 0l3.2442 3.2442L11.7474.3415c.3637-.4156.9955-.4577 1.4111-.094Z"/></svg>
                                    </span>
                                    <span className="gwt-InlineLabel">Added to Purchase Order</span>
                                  </button>
                                }

                            </div>
                          }
                        </div>
                      </div>
                    </div>
                    <hr/>
                  </lineitem>
                )}
              </div>
            }

        </div>
      </div>

      { showDeleteSupplierAssignmentModal &&
        <DeleteSupplierAssignmentModal
          payload={payload}
          showDeleteSupplierAssignmentModal={showDeleteSupplierAssignmentModal}
          setShowDeleteSupplierAssignmentModal={setShowDeleteSupplierAssignmentModal}
          supplier={activeSupplier}
          modalProductId={modalProductId}
          modalVariationId={modalVariationId}
          modalOptions={modalOptions}
          modalProductName={modalProductName}
          modalType={modalType}
          modalAssignment={modalAssignment}
          modalY={modalY}
        />
      }

    </>
  )

}

const mapStateToProps = state => ({
  assignments: state.assignments,
  thresholds: state.thresholds,
  continuationToken: state.assignments.assignments?.continuationToken,
  accountUnits: state.accounts.account.store_details.formatsAndUnits,
  purchaseOrderLines: state.purchaseOrderLines,
  settings: state.settings,
});

const mapDispatchToProps = (dispatch) => ({
  getAssignmentsPage: (payload, supplierId, continuationToken, page) => dispatch(assignmentsIndex(payload, supplierId, continuationToken, page)),
  addItem: (payload, itemData) => dispatch(purchaseOrderAddItem(payload, itemData)),
  getInventoryDetails: (payload, productId, variationId) => dispatch(inventoryDetails(payload, productId, variationId)),
  getRelatedThresholds: (payload, locationId, productId, variationId) => dispatch(getAssignmentThresholds(payload, locationId, productId, variationId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AssignmentList);